import React from 'react'

const IconArrow = ({size}) => {
    return (
        <svg className={'fill-current w-'+size+' h-'+size} viewBox="0 0 24 24"><path d="M13.025 1l-2.847 2.828 6.176 6.176h-16.354v3.992h16.354l-6.176 6.176 2.847 2.828 10.975-11z"/></svg>
    )
}

export default IconArrow
